var map = {
	"./Best Lawyers-dark.svg": 6384,
	"./Best Lawyers-light.svg": 4324,
	"./Chambers and Partners-dark.svg": 1273,
	"./Chambers and Partners-light.svg": 2591,
	"./Financial Times-dark.svg": 7620,
	"./Financial Times-light.svg": 9134,
	"./Forbes Club-dark.svg": 9777,
	"./Forbes Club-light.svg": 8773,
	"./LEGAL 500-dark.svg": 332,
	"./LEGAL 500-light.svg": 8281,
	"./Коммерсантъ-dark.svg": 1205,
	"./Коммерсантъ-light.svg": 1443,
	"./ПРАВО 300-dark.svg": 6664,
	"./ПРАВО 300-light.svg": 5520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5002;